import React from "react";
import AdminAddCountry from "../../Components/Admin/AdminAddCountry";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddCountryPage = ()=>{
    return (
      <AdminAddCountry />
    )
}

export default AdminAddCountryPage